import api, { ApiResponse } from './api';

/** The tenant workspace — not a Studio project (see projects.service.ts). */
export interface Workspace {
  id: string;
  name: string;
  config: Record<string, unknown>;
  fallback_rule_group_id: string | null;
}

export const workspaceService = {
  getWorkspace: async (id: string): Promise<Workspace> => {
    const response = await api.get<ApiResponse<Workspace>>(`/workspace/${id}`);
    return response.data.data!;
  },

  updateWorkspace: async (
    id: string,
    data: { name?: string; fallback_rule_group_id?: string | null },
  ): Promise<Workspace> => {
    const response = await api.put<ApiResponse<Workspace>>(`/workspace/${id}`, data);
    return response.data.data!;
  },
};
